import type { Languages } from '@common/types/config/Languages'

export function languageMatcher(
	attempts: readonly string[],
	available: ReadonlySet<string>,
	fallback: string,
): string {
	for (const language of attempts) {
		if (available.has(language)) return language
		const langOnly = language.split('-')[0]
		if (available.has(langOnly)) return langOnly
	}
	return fallback
}

export function matchLanguage(
	languages: Languages,
	attempts: readonly string[],
	requested?: string | null,
): string {
	const fallback = languages.default || 'fr'
	const available = new Set(languages.available || [])
	available.add(fallback)
	if (requested) attempts = [requested, ...attempts]
	return languageMatcher(attempts, available, fallback)
}
